import { cn } from '@/lib/format';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-800 border-primary-200',
  accent: 'bg-accent-100 text-accent-800 border-accent-200',
  secondary: 'bg-secondary-100 text-secondary-800 border-secondary-200',
};

interface CategoryBadgeProps {
  name: string;
  color?: string;
  icon?: string;
  className?: string;
}

export default function CategoryBadge({ name, color = 'primary', icon, className }: CategoryBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-xs font-label font-bold whitespace-nowrap',
        colorMap[color] ?? colorMap.primary,
        className,
      )}
    >
      {icon && (
        <span className="w-3.5 h-3.5 flex items-center justify-center">
          <i className={cn(icon, 'text-[13px]')} />
        </span>
      )}
      {name}
    </span>
  );
}